var _a, _b;
import { createSlice } from '@reduxjs/toolkit';
import { fetchPositionsReportData } from '../../_actions/asyncActions/Viewer/get_strategies_for_players';
import { getRakesReport } from '../../_actions/asyncActions/Viewer/get_strategies_for_rakes';
import { getOpenRaiseReport } from '../../_actions/asyncActions/Viewer/get_strategies_for_opens';
var initialState = {
    flopAgg: {
        boardFilter: '',
        rankFilter: [],
        suitFilter: [],
        cardFilter: [],
        connFilter: [],
        displayType: 'actions',
        sortOrder: '',
        sortedColumn: '',
        count: null,
        advancedRankFilter: {
            high: [],
            middle: [],
            low: [],
            subset: [],
        },
        averageFlopValue: {},
        selectedComboCells: new Set(),
        selectedDrawsCells: new Set(),
    },
    runoutsAgg: {
        currentField: [],
        sortedData: [],
        barsGraph: [],
        filterValue: 'suit',
        displayMode: 'pilars',
        view: (_a = localStorage.getItem('runoutViewMode')) !== null && _a !== void 0 ? _a : 'strategy',
        currentPlayer: null,
    },
    positionReport: {
        currentPosition: '',
        positionData: {
            isReportNotAvailable: true,
            cachePositions: [],
            positionsSizings: {},
            positionsCombos: [],
            positionsDraws: [],
            positionsRenderData: [],
            positionStrategies: [],
            positions: [],
        },
    },
    multiStackReport: {
        multiStackViewMode: 'many',
        currentMatrixStack: 0,
        tableStatsData: [],
    },
    crossTable: {
        reqFilters: {
            preflop: [],
            combo_draw_clusters: [],
            flop: [],
        },
        preflopHandsFilter: [],
        sortedAction: [],
        preflopHands: [],
        isPreflopApplied: false,
        isFlopFiltersOpened: false,
        appliedFilters: null,
        isBoardFilterApplied: false,
        isFirstSelectedCell: false,
    },
    rakeReport: {
        currentRake: '',
        rakeRenderFilter: [],
        rakeData: {
            cacheRake: [],
            rakeRenderData: [],
            rakeStrategies: [],
            rakeSizings: {},
            rakeCombos: [],
            rakeDraws: [],
            rakes: [],
        },
    },
    openRaiseReport: {
        currentOpenRaise: '',
        openRaiseRenderFilter: [],
        openRaiseData: {
            cacheOpenRaise: [],
            openRaiseRenderData: [],
            openRaiseStrategies: [],
            openRaiseSizings: {},
            openRaiseCombos: [],
            openRaiseDraws: [],
            openRaise: [],
        },
    },
    currentMultiReport: 'effStacks',
    isShowTune: (_b = localStorage.getItem('isShowTune')) !== null && _b !== void 0 ? _b : 'all',
};
var reports = createSlice({
    initialState: initialState,
    name: 'reports',
    reducers: {
        setCurrentReport: function (state, action) {
            state.currentMultiReport = action.payload;
        },
        setIsShowTune: function (state, action) {
            state.isShowTune = action.payload;
        },
        setApplyFilter: function (state, action) {
            state.flopAgg[action.payload.key] = action.payload.filterValue;
        },
        setApplyManyFlopFilters: function (state, action) {
            state.flopAgg = action.payload;
        },
        setRakeRenderData: function (state, action) {
            state.rakeReport.rakeData.rakeRenderData = action.payload;
        },
        setOpenRaiseRenderData: function (state, action) {
            state.openRaiseReport.openRaiseData.openRaiseRenderData = action.payload;
        },
        setRakeRenderFilter: function (state, action) {
            state.rakeReport.rakeRenderFilter = action.payload;
        },
        setOpenRaiseRenderFilter: function (state, action) {
            state.openRaiseReport.openRaiseRenderFilter = action.payload;
        },
        setSelectedComboCells: function (state, action) {
            state.flopAgg.selectedComboCells = action.payload;
        },
        setSelectedDrawsCells: function (state, action) {
            state.flopAgg.selectedDrawsCells = action.payload;
        },
        setCurrentPlayer: function (state, action) {
            state.runoutsAgg.currentPlayer = action.payload;
        },
        setIsPreflopApplied: function (state, action) {
            state.crossTable.isPreflopApplied = action.payload;
        },
        setIsFlopFiltersOpened: function (state, action) {
            state.crossTable.isFlopFiltersOpened = action.payload;
        },
        setPreflopHands: function (state, action) {
            state.crossTable.preflopHands = action.payload;
        },
        setAppliedFilters: function (state, action) {
            state.crossTable.appliedFilters = action.payload;
        },
        setCrossTableFilter: function (state, action) {
            state.crossTable.reqFilters = action.payload;
        },
        setApplyCrossTableFilter: function (state, action) {
            var _a = action.payload, filterKey = _a.filterKey, filterValue = _a.filterValue;
            state.crossTable['reqFilters'][filterKey] = filterValue;
        },
        setSortedActionCrossTableFilter: function (state, action) {
            state.crossTable['sortedAction'] = action.payload;
        },
        setPreflopHandsFilter: function (state, action) {
            state.crossTable.preflopHandsFilter = action.payload;
        },
        setIsBoardFilterAppliedCrossTable: function (state, action) {
            state.crossTable.isBoardFilterApplied = action.payload;
        },
        setIsFirstSelectedCellCrossTable: function (state, action) {
            state.crossTable['isFirstSelectedCell'] = action.payload;
        },
        setCountFlops: function (state, action) {
            state.flopAgg['count'] = action.payload.filterValue;
        },
        setCurrentField: function (state, action) {
            state.runoutsAgg.currentField = action.payload;
        },
        setSortedData: function (state, action) {
            state.runoutsAgg.sortedData = action.payload;
        },
        setBarsGraph: function (state, action) {
            state.runoutsAgg.barsGraph = action.payload;
        },
        setFilterValue: function (state, action) {
            state.runoutsAgg.filterValue = action.payload;
        },
        setDisplayMode: function (state, action) {
            state.runoutsAgg.displayMode = action.payload;
        },
        setView: function (state, action) {
            state.runoutsAgg.view = action.payload;
        },
        setMultiStackViewMode: function (state, action) {
            state.multiStackReport.multiStackViewMode = action.payload;
        },
        setCurrentMatrixStack: function (state, action) {
            state.multiStackReport.currentMatrixStack = action.payload;
        },
        setTableStatsData: function (state, action) {
            state.multiStackReport.tableStatsData = action.payload;
        },
        setCurrentPosition: function (state, action) {
            state.positionReport.currentPosition = action.payload;
        },
        setCurrentRake: function (state, action) {
            state.rakeReport.currentRake = action.payload;
        },
        setCurrentOpenRaise: function (state, action) {
            state.openRaiseReport.currentOpenRaise = action.payload;
        },
        setFilters: function (state, action) {
            state.positionReport.positionData.positionsDraws = action.payload.positionsDraws;
            state.positionReport.positionData.positionsCombos = action.payload.positionsCombos;
        },
        setRakeFilters: function (state, action) {
            state.rakeReport.rakeData.rakeCombos = action.payload.rakeCombos;
            state.rakeReport.rakeData.rakeDraws = action.payload.rakeDraws;
        },
        setOpenRaiseFilters: function (state, action) {
            state.openRaiseReport.openRaiseData.openRaiseCombos = action.payload.openRaiseCombos;
            state.openRaiseReport.openRaiseData.openRaiseDraws = action.payload.openRaiseDraws;
        },
        setPositionsRenderData: function (state, action) {
            state.positionReport.positionData.positionsRenderData = action.payload;
        },
        setAdvancedRankFilter: function (state, action) {
            state.flopAgg.advancedRankFilter = action.payload;
        },
        setAVGFlopValue: function (state, action) {
            state.flopAgg.averageFlopValue = action.payload;
        },
        resetPositionsData: function (state) {
            state.positionReport.positionData = {
                cachePositions: [],
                positionStrategies: [],
                positionsSizings: {},
                positionsCombos: [],
                positionsDraws: [],
                isReportNotAvailable: true,
                positions: [],
                positionsRenderData: [],
            };
        },
        resetRakeData: function (state) {
            state.rakeReport.rakeData = Object.assign({}, initialState.rakeReport.rakeData);
        },
        resetOpenRaiseData: function (state) {
            state.openRaiseReport.openRaiseData = Object.assign({}, initialState.openRaiseReport.openRaiseData);
        },
        resetFlopReport: function (state, action) {
            state.flopAgg = {
                boardFilter: '',
                rankFilter: [],
                suitFilter: [],
                cardFilter: [],
                connFilter: [],
                displayType: action.payload,
                sortOrder: '',
                sortedColumn: '',
                count: null,
                advancedRankFilter: {
                    high: [],
                    middle: [],
                    low: [],
                    subset: [],
                },
                averageFlopValue: {},
                selectedComboCells: new Set(),
                selectedDrawsCells: new Set(),
            };
            state.crossTable = {
                reqFilters: {
                    preflop: [],
                    combo_draw_clusters: [],
                    flop: [],
                },
                preflopHandsFilter: [],
                sortedAction: [],
                preflopHands: [],
                isPreflopApplied: false,
                isFlopFiltersOpened: false,
                appliedFilters: null,
                isBoardFilterApplied: false,
                isFirstSelectedCell: false,
            };
        },
        resetStateReports: function () {
            return initialState;
        },
    },
    extraReducers: function (builder) {
        builder.addCase(fetchPositionsReportData.fulfilled, function (state, action) {
            state.positionReport.positionData = action.payload;
        });
        builder.addCase(getOpenRaiseReport.fulfilled, function (state, action) {
            state.openRaiseReport.openRaiseData = action.payload;
        });
        builder.addCase(getRakesReport.fulfilled, function (state, action) {
            state.rakeReport.rakeData = action.payload;
        });
    },
});
export var reducer = reports.reducer, actions = reports.actions;
